<p-dialog
  appendTo="body"
  [style]="{width: '80vw'}"
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="visible"
  (visibleChange)="dialogVisibleChange($event)"
>
<ng-template pTemplate="content">
  <div *ngIf="isSaveing" class="loading-overlay">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <p-header>{{ 'TrackingItemImport.Header' | translate }}</p-header>
  <p-card>
    <div class="container">
      <div class="p-fluid formgrid grid">
          <div class="field col-12">
            <p-fileUpload
              #fileUpload
              [customUpload]="true"
              (uploadHandler)="fileUploader($event)"
              chooseLabel="{{ 'Common.Button.Select' | translate }}"
              uploadLabel="{{ 'Common.Button.Import' | translate }}"
              cancelLabel="{{ 'Common.Button.Cancel' | translate }}"
              accept=".xls,.xlsx"
            ></p-fileUpload>
          </div>
      </div>
    </div>
    <div class="mt-2">
      <laas-data-table
        scrollHeight="40%"
        [selectable]="false"
        [value]="trackingItemRows"
        [defaultColumns]="tableColumns"
        [rows]="this.pageInfo.pageSize"
        [totalRecords]="this.pageInfo.totalRecords"
        [loading]="isLoading"
        [lazy]="true"
      >
        <ng-template pTemplate="caption">
          <button
            pButton
            pRipple
            class="ml-2"
            label="{{ 'Common.Button.Save' | translate }}"
            [disabled]="trackingItemRows.length === 0"
            (click)="saveBtnClick($event)"
          ></button>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchDefault>
                <div [ngSwitch]="col.dataType">
                  <ng-container *ngSwitchCase="'date'">
                    {{ rowData[col.field] | date:'yyyy/MM/dd':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    {{ rowData[col.field] | replaceNullWith:'-'}}
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>
</ng-template>
</p-dialog>
